import { IFileUploadState } from "@edp-store/state/file-upload.state";
import { createSelector } from "@ngrx/store";
import { IAppState } from "../state/app.state";

const fileUploadSelector = (state: IAppState) => state.uploadedFile;

export const getUploadedFile = createSelector(fileUploadSelector, (state: IFileUploadState) => state.uploadedFile);
export const getAndroidFile = createSelector(fileUploadSelector, (state: IFileUploadState) => state.androidFile);

export const getUploadedFiles = createSelector(fileUploadSelector, (state: IFileUploadState) => state.uploadedFiles);
